module.exports = __webpack_public_path__ + "0bb5ec2caa864dd82a451ec61b25befd.png";